import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { NOTIFICATION_VARIANT } from "@/constants";

export type NotificationVariant =
  (typeof NOTIFICATION_VARIANT)[keyof typeof NOTIFICATION_VARIANT];

/** Default i18n namespace used when none is provided in the payload. */
const DEFAULT_NOTIFICATION_NS = "common";

/** i18n key for the canonical "something went wrong" error message. */
const API_ERROR_MESSAGE_KEY = "errors.apiTryAgain";

export type NotificationState = {
  open: boolean;
  variant: NotificationVariant;
  messageKey: string;
  messageNs: string;
};

export type ShowNotificationPayload = {
  variant: NotificationVariant;
  messageKey: string;
  messageNs?: string;
};

export const notificationInitialState: NotificationState = {
  open: false,
  variant: NOTIFICATION_VARIANT.ERROR,
  messageKey: API_ERROR_MESSAGE_KEY,
  messageNs: DEFAULT_NOTIFICATION_NS,
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState: notificationInitialState,
  reducers: {
    showNotification(
      state,
      action: PayloadAction<ShowNotificationPayload>,
    ) {
      state.open = true;
      state.variant = action.payload.variant;
      state.messageKey = action.payload.messageKey;
      state.messageNs = action.payload.messageNs ?? DEFAULT_NOTIFICATION_NS;
    },
    showApiErrorNotification(state) {
      state.open = true;
      state.variant = NOTIFICATION_VARIANT.ERROR;
      state.messageKey = API_ERROR_MESSAGE_KEY;
      state.messageNs = DEFAULT_NOTIFICATION_NS;
    },
    hideNotification(state) {
      state.open = false;
    },
  },
});

export const { showNotification, showApiErrorNotification, hideNotification } =
  notificationSlice.actions;

export const notificationReducer = notificationSlice.reducer;
